<template>
	<div>
		<TableList v-bind="getData" @on-radio-change="checkChange"></TableList>
		<div class="text-right margin-top-15">
			<vButton @click="click" theme="primary">{{$t('global.common.update_OK',{defaultValue:'确定'})}}</vButton>
			<vButton class="margin-left-10" @click="cancel" >{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</vButton>
		</div>
	</div>
</template>
<script>
import { HttpQueryB2BOrderList,HttpB2cAdminList,HttpQueryTransportOrderList } from "@/service/bespeak";
import TableList from "@components/templates/tablelist"
import { mapState,mapGetters,mapMutations } from "vuex";
export default {
	props:['products','ordertype','linkedNo'],
	components: {
		TableList
	},
	methods: {
		checkChange(rows, val) {
			// console.log(rows)
			this.rows = rows
		},
		click() {
			this.$emit('rows', this.rows)
		},
		cancel(){
			this.$emit('cancel')
		},
	},
	computed: {
        ...mapGetters('dictionary', ['getNextOrgList','getNewAllProductList']),
		getData() {
			return {
				ajaxRequest: this.ordertype==2 ? HttpB2cAdminList: this.ordertype==1 ? HttpQueryB2BOrderList : HttpQueryTransportOrderList,
				startUp: true,
				Searchs: {
					show: true,
					style: "border:none;",
					// labelWidth: 'auto',
					align: "left"
				},
				SearchsData: [
                    {
                        label: this.$t('fbb.billDelivery.sourceNo', { defaultValue: "关联单号" }),
                        tag: 'vInput',
                        key: this.ordertype==2?"EQ_deliverOrderNo":this.ordertype==1 ? 'EQ_subTransferPlanNo' : 'EQ_transitPlanOrderNo',
                        show: true,
                    },
                    {
                        label: this.$t('fbb.alloment.client_organization',{defaultValue:'客户'}),
                        key: this.ordertype==2?"EQ_orgId":"EQ_organizationId",
                        tag:'Select',
                        options:this.getNextOrgList,
                        required:false,
                        show: true,
                        props:{
                            filterable:true,
                            clearable:true,
                        },
                    },
                    {
                        label:this.$t('global.common.project',{defaultValue:'项目'}),
                        key:'EQ_lineId',
                        tag:'Select',
                        options:this.getNewAllProductList,
                        show: true,
                        props:{
                            filterable:true,
                            clearable:true,
                        },
                    },
                ],
				columns: [{
					type: 'selection',
					width: 50,
					align: "center",
					formName: 'id',
					isRadio:true,
				}, {
					title: this.$t('fbb.billDelivery.sourceNo', { defaultValue: "关联单号" }),
					key: this.ordertype==2?'deliverOrderNo':this.ordertype==1 ? 'subTransferPlanNo': "transitPlanOrderNo"
				}, {
					title: this.$t('fbb.alloment.client_organization',{defaultValue:'客户'}),
					key: 'organizationId',
                    render:(h,{row})=>{
                        const id = this.ordertype==2?row.orgId:row.organizationId;
                        const orgname = this.getNextOrgList.filter((item) => {
                            return id == item.value
                        })[0] || {};
                        return <div>{orgname.label||'-'}</div>
                    }
                },
                {
					title: this.$t('global.common.project',{defaultValue:'项目'}),
                    key: 'lineId',
                    render:(h,{row})=>{
                        const id = row.lineId;
                        const product = this.getNewAllProductList.filter((item) => {
                            return id == item.value
                        })[0] || {};
                        return <div>{product.label||'-'}</div>
                    }
                },
                ]
			}
		}
	},
}
</script>